import { Dispatch } from 'react';
import { PayloadAction } from 'typesafe-actions';
import { createContext } from 'use-context-selector';
import { CardDetailsContextActionTypes, CardDetailsState } from './types';
import { defaultCardDetailsProviderState } from './defaultState';

const CardDetailsContext = createContext<CardDetailsState>(defaultCardDetailsProviderState);
const CardDetailsDispatchContext = createContext<
  Dispatch<PayloadAction<CardDetailsContextActionTypes, any>> | undefined
>(undefined);

export { CardDetailsContext, CardDetailsDispatchContext };
